import request from '@/axios/axios'

// 设备标签列表
export function getList(query) {
  return request({
    url: '/ota/v1/device/tag/get-device-tag-list',
    method: 'post',
    data: query
  })
}

// 删除设备标签列表
export function deleteEquipmentLabels(query) {
  return request({
    url: '/ota/v1/device/tag/delete-device-tag',
    method: 'post',
    data: query
  })
}

// 新增标签
export function addLabels(query) {
  return request({
    url: '/ota//v1/device/tag/add-device-tag',
    method: 'post',
    data: query
  })
}

// 设备标签详情列表
export function getDetailsList(query) {
  return request({
    url: '/ota/v1/device/tag/detail/get-device-tag-detail-list',
    method: 'post',
    data: query
  })
}

// 删除设备标签详情
export function deleteLabelsDetails(query) {
  return request({
    url: '/ota/v1/device/tag/detail/delete-device-tag-detail',
    method: 'post',
    data: query
  })
}

// 设备标签模板url
export function template(query) {
  return request({
    url: 'ota/v1/device/tag/detail/get-device-tag-template',
    method: 'post',
    data: query
  })
}

// 保存设备标签csv文件
export function saveFile(query) {
  return request({
    url: 'ota/v1/device/tag/detail/save-csv-file',
    method: 'post',
    data: query
  })
}

// 查询某个设备标签详情
export function deviceTagDetail(query) {
  return request({
    url: 'ota/v1/device/tag/detail/get-device-tag-detail',
    method: 'post',
    data: query
  })
}


